enum LogoPositionOptions {
  INSIDE_BOX = 'INSIDE_BOX',
  OUTSIDE_BOX = 'OUTSIDE_BOX'
}

enum HorizontalAlignmentOptions {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  CENTER = 'CENTER'
}

enum VerticalAlignmentOptions {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
  CENTER = 'CENTER'
}

enum BorderRadiusOptions {
  NONE = 'none',
  SM = 'sm',
  MD = 'md',
  LG = 'lg'
}

export interface ApplicationCustomizationSettings {
  name?: string;
  supportEmail?: string;
  termsOfServiceUrl?: string;
  privacyPolicyUrl?: string;
  enableEventsTabForScim?: boolean;
  organizationMetaName?: string;
}

export interface PortalCustomizationSettings {
  buttonColor?: string;
  textColor?: string;
  buttonHoverColor?: string;
  loginBgColor?: string;
  logoUrl?: string;
  iconUrl?: string;
  disallowDisableEnabledConnection?: boolean; // controls for both SSO and SCIM
  logoPosition?: LogoPositionOptions;
  logoAlignment?: HorizontalAlignmentOptions;
  headerTextAlignment?: HorizontalAlignmentOptions;
  socialPlacement?: VerticalAlignmentOptions;
  borderRadius?: BorderRadiusOptions;
  pageBackgroundCss?: string;
}

export interface CustomizationSettings {
  portalCustomization?: PortalCustomizationSettings;
  applicationCustomization?: ApplicationCustomizationSettings;
}

export interface CustomizationResponse {
  environmentId?: string;
  customizations?: CustomizationSettings; // @todo Lets remove this property in the final draft
  customizationSettings?: CustomizationSettings;
}

export {
  LogoPositionOptions,
  HorizontalAlignmentOptions,
  VerticalAlignmentOptions,
  BorderRadiusOptions
};
